import React, { useState } from 'react';
import I18n from 'i18n-js';
import { IssueIcon } from 'components/cwo-icons';
import TicketModalForm from 'components/tickets-form/TicketModalForm';
import {
  arrayOf, number, shape, string,
} from 'prop-types';

// Temporary solution to show the "Create Issue" button only
// for Cherkizovo company and specific users
const CHERKIZOVO_COMPANY_ID = 67;
const CHERKIZOVO_USERS_IDS = new Set([233, 172_390]);

const Issue = ({
  ticketStatuses = [],
  ticketPriorities = [],
  ticketTypes = [],
  ticketCommitmentLevels = [],
  ticketDevStages = [],
  ticketDevStatuses = [],
  ticketSizes = [],
  ticketCwoModules = [],
  currentUserInfo = {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
    companyId: null,
  },
  responsibleUserInfo = {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
  },
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    currentUserInfo.companyId === CHERKIZOVO_COMPANY_ID
      && (CHERKIZOVO_USERS_IDS.has(currentUserInfo.id) || currentUserInfo.type === 'AdminUser') && (
      <>
        <button
          type="button"
          className="trigger-btn btn btn-success"
          style={{ marginBottom: 0 }}
          onClick={() => setIsModalOpen(true)}
        >
          <IssueIcon />
          <span className="trigger-btn__label">
            {I18n.t('shared.side_menu.issue')}
          </span>
        </button>

        <TicketModalForm
          currentUserInfo={currentUserInfo}
          statuses={ticketStatuses}
          priorities={ticketPriorities}
          ticketTypes={ticketTypes}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          newTicketModal={isModalOpen}
          ticketFromDashboard={false}
          responsibleUserInfo={responsibleUserInfo}
          commitmentLevels={ticketCommitmentLevels}
          devStages={ticketDevStages}
          devStatuses={ticketDevStatuses}
          sizes={ticketSizes}
          cwoModules={ticketCwoModules}
        />
      </>
    )
  );
};

Issue.propTypes = {
  currentUserInfo: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
    companyId: number,
  }),
  ticketStatuses: arrayOf(string),
  ticketPriorities: arrayOf(string),
  ticketTypes: arrayOf(string),
  responsibleUserInfo: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
  }),
  ticketCommitmentLevels: arrayOf(string),
  ticketDevStages: arrayOf(string),
  ticketDevStatuses: arrayOf(string),
  ticketSizes: arrayOf(string),
  ticketCwoModules: arrayOf(string),
};

export default Issue;
